import { render, staticRenderFns } from "./homeSwiper.vue?vue&type=template&id=12220a8a&"
import script from "./homeSwiper.vue?vue&type=script&lang=js&"
export * from "./homeSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports